<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">

      <Form ref="formValidate" :model="params" :rules="ruleValidate" :label-width="100">
        <FormItem label="账号：" prop="username">
          <Input maxlength="128" v-model.trim="params.username" :disabled="usernameDis" placeholder="请输入账号"></Input>
        </FormItem>
        <FormItem label="密码：" prop="password" v-if="!usernameDis">
          <Input maxlength="128" type="password" v-model.trim="params.password"
                 placeholder="请输入密码"></Input>
        </FormItem>
        <FormItem label="姓名：" prop="realName">
          <Input v-model.trim="params.realName" placeholder="请输入姓名"></Input>
        </FormItem>
        <FormItem label="商户名称：" prop="companyName">
          <Input v-model.trim="params.companyName" placeholder="请输入商户名称"></Input>
        </FormItem>
        <FormItem label="联系方式：" prop="phone">
          <Input v-model.trim="params.phone" placeholder="请输入联系方式"></Input>
        </FormItem>
        <FormItem label="联系地址：" prop="address">
          <Input v-model.trim="params.address" placeholder="请输入联系地址"></Input>
        </FormItem>
<!--        <FormItem label="公众号消息ID：" prop="tagid" v-if="!usernameDis">-->
<!--          <Input v-model.trim="params.tagid" placeholder="公众号消息ID"></Input>-->
<!--        </FormItem>-->
<!--        <FormItem label="经度" prop="longitude">-->
<!--          <Input v-model.trim="params.longitude" placeholder="经度"></Input>-->
<!--        </FormItem>-->
<!--        <FormItem label="纬度" prop="latitude">-->
<!--          <Input v-model.trim="params.latitude" placeholder="纬度"></Input>-->
<!--        </FormItem>-->
        <FormItem label="开通地区：" prop="regionId">
          <Select v-model="params.regionIds" filterable multiple>
            <Option v-for="item in regionList" :value="item.regionId" :key="item.value">{{ item.fullName }}</Option>
          </Select>
        </FormItem>
      </Form>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
        <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
          <span v-if="!loadingBtn">确定</span>
          <span v-else>请稍候...</span>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tenant-ope",
  props: ['regionList'],
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      usernameDis: false,
      title: '查看信息',
      type: 0,
      params: {
        username: '',
        realName: '',
        regionIds: '',
        password: '',
        address: '',
        tenantId: '',
        tagid: '',
        longitude: '',
        latitude: ''
      },
      ruleValidate: {
        username: [
          {required: true, message: '账号不能为空', trigger: 'change'},
          {max: 128, message: '账号名称过长', trigger: 'change'}
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'change'},
          {max: 128, message: '密码名称过长', trigger: 'change'}
        ],
        realName: [
          {required: true, message: '姓名不能为空', trigger: 'change'},
          {max: 20, message: '账号名称过长', trigger: 'change'}
        ],
        // tagid: [
        //   {required: true, message: '公众号消息ID', trigger: 'change'},
        // ]
      }
    }
  },
  methods: {
    // 点击提交验证
    handleSubmit(name) {
      // console.log(this.params);
      this.$refs[name].validate((valid) => {
        if (valid) {
          /**
           * type判断
           * 1.查看 2.新增 3.编辑
           */
          switch (this.type) {
            case 1:
              break;
            case 2:
              // 新增区域商户
              this.addAdmin();
              break;
            case 3:
              // 编辑区域商户
              this.updateAdmin();
              break;
            default:
              this.$Notice.error({
                title: '区域商户管理',
                desc: '查看，新增，编辑区分判断报错',
                duration: 0
              });
              break
          }
        } else {
          this.$Message.error('还有信息没有填写合格哦~');
        }
      })
    },
    // 显示模态框
    show(type, row) {
      this.isShowModal = true;
      this.type = type;
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      switch (type) {
        case 1:
          this.title = '查看区域商户';
          this.findAdminUserById(row);
          break;
        case 2:
          this.title = '新增区域商户';
          break;
        case 3:
          this.title = '编辑区域商户';
          this.findAdminUserById(row);
          break;
        default:
          this.$Notice.error({
            title: '区域商户管理',
            desc: '查看，新增，编辑模态框报错',
            duration: 0
          });
          break
      }
    },
    // 新增区域商户
    addAdmin() {
      console.log('this.params', this.params);
      this.$Spin.show();
      this.axios.post('/tenant/add', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$emit('changeDate');
          this.$Message.success('操作成功.');
          this.hide('formValidate');
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '新增区域商户接口报错',
            duration: 0
          });
        }
      })
    },
    // 编辑区域商户
    updateAdmin() {
      this.$Spin.show();
      this.axios.post('/tenant/update', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$emit('changeDate');
          this.$Message.success('操作成功.');
          this.hide('formValidate');
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '编辑区域商户接口报错',
            duration: 0
          });
        }
      })
    },
    // 查询区域商户详情
    findAdminUserById(row) {
      this.$Spin.show();
      this.axios.post('/tenant/getById', {
        tenantId: row.tenantId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.params.tenantId = res.data.tenantId;
          this.params.realName = res.data.realName;
          this.params.companyName = res.data.companyName;
          this.params.phone = res.data.phone;
          this.params.address = res.data.address;
          this.params.username = row.username
          this.params.tagid = res.data.tagid
          this.params.regionIds = res.data.regionIds
          this.params.longitude = res.data.longitude
          this.params.latitude = res.data.latitude
          this.usernameDis = true;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查看区域商户详情接口报错',
            duration: 0
          });
        }
      })
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      this.params.adminId = '';
      this.usernameDis = false;
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>

</style>